import { createContext, useContext } from 'react';

import type { CurrentMarketplaceUserQuery } from './__generated__/Provider.graphql.ts';

const CurrentMarketplaceUserContext = createContext<
  CurrentMarketplaceUserQuery['currentUser'] | null
>(null);

export const useCurrentMarketplaceUserContext = () =>
  useContext(CurrentMarketplaceUserContext)!;

export const CurrentMarketplaceUserProvider =
  CurrentMarketplaceUserContext.Provider;
